export default function hideIfEmpty(value, arr) {
  return value ? arr : [];
}
